<div>
	@if(this.link() || this.name()){
		<a 
			href="#"
			class="text-primary"
			[routerLink]="destination()"
			[queryParams]="getQueryParams()"
			[fragment]="getFragment()"
		>
			<i class="fa-solid fa-arrow-left"></i> Retour
		</a>
	}
	@else{
		<a 
			href="#"
			class="text-primary"
			[routerLink]="destination()"
		>
			<i class="fa-solid fa-arrow-left"></i> Retour
		</a>
	}
</div>